import Reveal from "@/components/Reveal";

const SectionHeader = ({ eyebrow, title, description, align = "center", dark = false }) => {
  const alignCls = align === "center" ? "mx-auto text-center items-center" : "text-left items-start";
  return (
    <Reveal className={`flex max-w-2xl flex-col gap-4 ${alignCls}`}>
      {eyebrow && (
        <span className="eyebrow" data-testid="section-eyebrow">
          <span className="h-px w-6 bg-kryvo-lime" aria-hidden="true" />
          {eyebrow}
        </span>
      )}
      <h2
        className={`text-balance text-3xl font-semibold sm:text-4xl lg:text-5xl ${
          dark ? "text-white" : "text-kryvo-ink"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`text-base leading-relaxed sm:text-lg ${dark ? "text-white/70" : "text-kryvo-ink/65"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
};

export default SectionHeader;
